import React from 'react'
import { Link } from "react-router-dom";
import ClinicDashboard from "./pages/ClinicDashboard";
import "./clinics.css";
const Clinics = () => {
    return ( 
        <>
        <div className="container container-xxl">
        <div className="pagetitle d-flex justify-content-between">
                  <h1>Clinics</h1>
                  <div>
                        
                        <Link to="/clinics/new" className="btn btn-sm btn-primary"><i className="bi bi-plus"></i> Add Clinic</Link>
                  </div>
              </div>

              <ClinicDashboard/>
        </div>
            
          
        </>
     );
}
 
export default Clinics;